import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { MappingCell, DirectCell, YesNoCell, CellFunction } from '../../cells';
import { IEpxSubAbuse } from '../../../../../libs/apps/epxsubabuse';

const EpxSubAbuseTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxSubAbuse>[] = [
    {
      Header: 'Use',
      id: 'slipped',
      Cell: ResponseGuard(YesNoCell('slipped') as CellFunction<IEpxSubAbuse>)
    },
    {
      Header: 'Used Days Ago',
      id: 'slippedDaysAgo',
      Cell: ResponseGuard(
        DirectCell('slippedDaysAgo') as CellFunction<IEpxSubAbuse>
      )
    },
    {
      Header: 'Trigger Frequency',
      id: 'triggerFrequency',
      Cell: ResponseGuard(
        MappingCell('triggerFrequency', {
          1: 'Not At All',
          2: 'A Little',
          3: 'A Lot'
        }) as CellFunction<IEpxSubAbuse>
      )
    },
    {
      Header: 'Support Groups',
      id: 'supportGroupCount',
      Cell: ResponseGuard(
        DirectCell('supportGroupCount') as CellFunction<IEpxSubAbuse>
      )
    },
    {
      Header: 'Checkup OK',
      id: 'everythingOk',
      Cell: ResponseGuard(
        YesNoCell('everythingOk') as CellFunction<IEpxSubAbuse>
      )
    }
  ];
  return (
    <SessionTable<IEpxSubAbuse>
      url="/epxsubabuse/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxSubAbuseTable;
